const filterItemsUseCase = ({ itemList, textFilter, fieldsFilter, numberItems = 10 }) => {
    return itemList
        .filter(item => {
            if (!textFilter || textFilter.trim() === "") {
                return true
            }

            const texts = textFilter.trim().toLowerCase().split(" ")
            const adaptData = d => d != null ? String(d).toLowerCase() : ""
            const fields = fieldsFilter.map(field => adaptData(item[field])).join("")
            return texts.every(t => fields.includes(t))
        })
        .slice(0, numberItems)
}

export default filterItemsUseCase